var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 112,
    viewBox: "0 0 134 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M129.548 20.252C132.424 27.7776 134 35.9536 134 44.4987C134 81.7788 104.003 112 67 112C29.9969 112 0 81.7788 0 44.4987C0 35.9536 1.57633 27.7776 4.45232 20.252H129.548Z",
    fill: "#22A852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.707 44.4987C122.707 75.4957 97.7666 100.623 67 100.623C36.2334 100.623 11.2925 75.4957 11.2925 44.4987C11.2925 35.8148 13.25 27.5905 16.7457 20.252H117.254C120.75 27.5905 122.707 35.8148 122.707 44.4987Z",
    fill: "#22A852"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M66.9999 88.997C91.3931 88.997 111.168 69.0743 111.168 44.4985C111.168 19.9226 91.3931 0 66.9999 0C42.6067 0 22.832 19.9226 22.832 44.4985C22.832 69.0743 42.6067 88.997 66.9999 88.997Z",
    fill: "#22A852"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9999 77.6586C85.1775 77.6586 99.9134 62.8124 99.9134 44.4987C99.9134 26.185 85.1775 11.3389 66.9999 11.3389C48.8223 11.3389 34.0864 26.185 34.0864 44.4987C34.0864 62.8124 48.8223 77.6586 66.9999 77.6586Z",
    fill: "#22A852"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7571 59.3319L46.4105 44.3971C45.5338 43.2426 45.7514 41.5913 46.8974 40.7068C48.0434 39.8235 49.6824 40.0428 50.5603 41.1973L58.4543 51.5883C59.3838 52.811 61.1507 52.9732 62.2832 51.9389L83.732 32.345C84.8005 31.3688 86.4531 31.4506 87.422 32.5271C88.3909 33.6036 88.3098 35.2685 87.2413 36.2447L61.586 59.6825C60.4536 60.7169 58.6854 60.5559 57.7571 59.3319Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/payment-success.aef0855cf770a6374235961f22eae72c.svg";
export { ForwardRef as ReactComponent };